import React, { useState, useEffect } from 'react';
import {Link} from "react-router5";
import {useTranslation} from "react-i18next";
import { subscribe, unsubscribe } from '../sw/sw_subscribe';
import { fetch_api_json } from '../api';
import { SmallLoader } from "../utils/loader";

const SCOPE = "/desktop/";

function getRegistrationInfo(reg) {
  return reg && reg.pushManager.getSubscription().then(sub => {
    return {registration: reg, subscription: sub};
  })
}

export function NotificationMenu() {
  const { t } = useTranslation();

  const [show_advanced, setShowAdvanced] = useState(false);
  const [sub_pending, setSubPending] = useState(false);
  const [pong_pending, setPongPending] = useState(false);
  // const [registrations, setRegistrations] = useState([]);
  const [current_registration_wrapper, setCurrentRegistrationWrapper] = useState(null);
  const [, setPermission] = useState(Notification.permission);

  const loadCurrentRegistration = () => {
    return navigator.serviceWorker.getRegistration(SCOPE).then(function(registration) {
      return registration && getRegistrationInfo(registration).then(setCurrentRegistrationWrapper)
    })
  }

  useEffect(() => {
    loadCurrentRegistration();
  }, [])

  function toggleSubscribe(reg, sub) {
    if (sub) {
      return unsubscribe(reg).then(() => {
	loadCurrentRegistration();
      })
    } else {
      return subscribe(reg).then(() => {
	loadCurrentRegistration();
      }).catch((err) => {
	console.log("[sw subscribe error] ", err.error || err)
      })
    }
  }

  function requestNotificationPermission() {
    return Notification.requestPermission((permission) => {
      console.log("permission asked")
      // If the user accepts, let's create a notification
      setPermission(permission)
      if (permission === "granted") {
        new Notification(t("Notification activated"));
	return true;
      }
      return false;
    });
  }

  function requestPermissionAndMaySubscribe() {
    setSubPending(true);
    const {registration, subscription} = current_registration_wrapper || {};

    let promise;
    if (Notification.permission == "granted") {
      promise = toggleSubscribe(registration, subscription);
    } else {
      promise = requestNotificationPermission().then((granted) => {
        return toggleSubscribe(registration, subscription);
      })
    }

    promise.then(() => setSubPending(false))
  }

  const ping = (endpoint)  => {
    if (! endpoint) { return; }

    setPongPending(true);

    fetch_api_json("post", "/notification/ping", {endpoint}).then((results) => {
      setPongPending(false);

      let txt;

      const result_for_endpoint = results.find(res => res.endpoint == endpoint);

      console.log(result_for_endpoint);
      if (result_for_endpoint == null) {
        txt = t("Not found")
      } else {
        txt = {
          "sent": t("sent"),
          "deleted": t("deleted"),
          "error": t("error"),
        }[result_for_endpoint.result]
      }

      alert(txt)
    }).catch((err) => {
      console.log(err);
      alert("An error occured")
    })
  }
  
  const {
    registration: current_registration,
    subscription: current_subscription
  } = current_registration_wrapper || {};


  return <div className={'MainMenuContainer'}>
    <div className={'topMainMenu'}>
	<Link routeName='settings' routeOptions={{reload: true}}>  <div className={'topMainBack'}></div></Link>
	<div className={'topMainTitle'}>{t('Notification')}</div>
    </div>

    <div className={'MainMenuItem'} onClick={requestPermissionAndMaySubscribe} style={{cursor: "pointer"}}>
      { current_subscription && t("Deactivate subscription") || t("Activate subscription and notification")}
      {
	sub_pending
	? <SmallLoader />
	: (
	  current_subscription
	  ? <div className={'MainMenuItemChecked'} />
	  : <div className={'MainMenuItemUnchecked'} />
	)
      }
    </div>

    <div className="MainMenuItem" onClick={() => setShowAdvanced(!show_advanced)} style={{cursor: "pointer"}}>
	<span>{ t("Advanced parameters") }</span>
	<div className={show_advanced ? 'settingMenuItemChevronDown' : 'settingMenuItemChevron'} style={{marginRight: "10px"}} />
    </div>

    { show_advanced &&
    <div style={{marginLeft: "20px", borderLeft: "1px solid var(--theme-primary-blue1)"}}>
      <div className={'MainMenuItem'}>
	{ t("Notification display") }
	{
	  <div>
	    {
	      {
		granted: t("Granted"),
		denied: t("Denied"),
		default: t("Unset (will be denied)")
	      }[Notification.permission]
	    }
	  </div>
	}
      </div>

      <div className={'MainMenuItem'}>
	{ t("Subscription info") }
	{
	  current_subscription
	  ? <div style={{paddingLeft: "5px"}}>{current_subscription.endpoint}</div>
	  : <div>{t("No subscription")}</div>
	}
      </div>

      { current_subscription &&
	<div className="MainMenuItem" style={{cursor: "pointer"}}
	     onClick={() => ping(current_subscription.endpoint)}>
	  { t("Ping") }
	  {
	    pong_pending
	    ? <SmallLoader />
	    : <div className={'MainMenuItemChecked'} />
	  }
	</div>
      }
    </div> }
  </div>
}
